<template>
    <div class="container py-4">
        <div class="row">
            <div class="col-12 col-md-6 mb-4">
                <h3 class="text-center text-primary">{{ __('Program guide') }}</h3>
                <div class="browser-box p-3 border rounded shadow-sm bg-light custom-scroll">
                    <BrowseByType
                        type="issuu"
                        subtype="program_guide"
                        :category-route="categoryRoute"
                        :locale="locale"
                        :news-endpoint="newsEndpoint"
                        @meta-loaded="handleMetaLoaded('program_guide', $event.total)"
                    />
                </div>
            </div>
            <div class="col-12 col-md-6 mb-4">
                <h3 class="text-center text-primary">{{ __('Harmony') }}</h3>
                <div class="browser-box p-3 border rounded shadow-sm bg-light custom-scroll">
                    <BrowseByType
                        type="issuu"
                        subtype="harmony"
                        :category-route="categoryRoute"
                        :locale="locale"
                        :news-endpoint="newsEndpoint"
                        @meta-loaded="handleMetaLoaded('harmony', $event.total)"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BrowseByType from '../newsbrowser/BrowseByType.vue'

export default {
    props: {
        category: {
            type: Number,
            default: null
        },
        categoryRoute: {
            type: String,
            required: true
        },
        locale: {
            type: String,
            required: true
        },
        newsEndpoint: {
            type: String,
            required: true
        },
    },
    components: {
        BrowseByType,
    },
    data() {
        return {
            programGuideTotal: null,
            harmonyTotal: null,
        }
    },
    methods: {
        handleMetaLoaded(type, total) {
            if (type === 'program_guide') {
                this.programGuideTotal = total
            }

            if (type === 'harmony') {
                this.harmonyTotal = total
            }

            if (this.programGuideTotal !== null && this.harmonyTotal !== null) {
                this.$emit('meta-loaded', this.programGuideTotal + this.harmonyTotal)
            }
        }
    }
}
</script>

<style scoped>
.browser-box {
    max-height: 500px;
    overflow-y: auto;
}

.custom-scroll::-webkit-scrollbar {
    width: 8px;
}

.custom-scroll::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
}

.custom-scroll::-webkit-scrollbar-thumb {
    background: #0068B1;
    border-radius: 10px;
}
</style>
